/**
 * EQuIP Measure Display Constants
 *
 * Canonical measure-name union + presentation constants for the leadership
 * heatmap and other grids. The measure × role × quarter *activation* matrix
 * is no longer hardcoded here — it is sourced from
 * `och.equip_config_measure_schedule` via the selectors in
 * `./measureScheduleSelectors.ts` (use `getActiveMeasureNames`,
 * `getLeadershipMeasureColumnsFromSchedule`, etc.).
 */

export type MeasureName =
  | 'AWV'
  | 'A1C'
  | 'BCS'
  | 'CRCS'
  | 'PHQ9'
  | 'HTN'
  | 'ACP'
  | 'ACO_Visits'
  | 'ED_SendOut'
  | 'PIMs'
  | 'Coding'
  | 'Quality_Audit'

/** Canonical column ordering for the leadership heatmap grid. */
export const MEASURE_DISPLAY_ORDER: MeasureName[] = [
  'AWV', 'A1C', 'BCS', 'CRCS', 'PHQ9', 'HTN', 'ACP',
  'ACO_Visits', 'ED_SendOut', 'PIMs', 'Coding', 'Quality_Audit',
]

/** Human-readable column headers for the leadership heatmap. */
export const MEASURE_DISPLAY_NAMES: Record<MeasureName, string> = {
  AWV: 'AWV',
  A1C: 'A1C',
  BCS: 'BCS',
  CRCS: 'CRCS',
  PHQ9: 'PHQ9',
  HTN: 'HTN',
  ACP: 'ACP',
  ACO_Visits: 'ACO Visits',
  ED_SendOut: 'ED Sendout',
  PIMs: 'PIMs',
  Coding: 'Coding',
  Quality_Audit: 'Sig. Standards',
}
